import moment from 'moment';
import React, { lazy, useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Modal = require(`globalcomponents/UI/Modal/${layout}`).default;
const FormStyle = require(`globalcomponents/UI/Form/${layout}/serverStyle`).default;
const Button = lazy(() => import(`globalcomponents/UI/Button/${layout}`));
const Payment = lazy(() => import(`globalcomponents/Payment/${layout}`));

const Component = ({ Styled, i18n, updateSuspendedCard, callback }) => {
  const history = useHistory();
  const [open, setOpen] = useState(false);

  const { contractStartDate, contractFinishDate } = useRef(
    history?.location?.state || {}
  ).current;

  const clickedModal = () => {
    setOpen(true);
  };

  const closeModal = () => {
    setOpen(false);
  };

  const [ModalListObject, setModalListObject] = useState({
    header: '',
    content: () => {
      return null;
    }
  });

  const cardDetails = (data) => {
    let obj = {
      cardHolderName: data.cardHolderName,
      stripeToken: data.stripeToken
    };
    let apiId = 'updateCardDetails';
    updateSuspendedCard({
      apiId,
      data: obj,
      callback: callback,
      history: history,
      i18n: i18n
    });
    closeModal();
  };

  return (
    <Styled.Wrapper>
      {contractStartDate && contractFinishDate ? (
        <p>
          {i18n.t('suspended.description')}{' '}
          <span className="date">
            {moment(contractStartDate).format('MM/DD/YYYY')}
          </span>{' '}
          {i18n.t('suspended.to')}{' '}
          <span className="date">
            {moment(contractFinishDate).format('MM/DD/YYYY')}
          </span>
          {/* You have active contract from  to  */}
        </p>
      ) : (
        <p>{i18n.t('suspended.expiredContract')}</p>
      )}
      <FormStyle.ButtonsWrapper className="payCard">
        <Button
          type="submit"
          className="buttonStyle"
          label={i18n.t('suspended.payButtonText')}
          onClick={() => {
            clickedModal();
            setModalListObject({
              header: '',
              content: () => {
                return (
                  <div className="suspendedCompanyPay">
                    <Payment
                      getEmail
                      suspended
                      buttonLabel={i18n.t('suspended.saveButtonText')}
                      handleOnChange={() => {}}
                      updateCard={(data) => cardDetails(data)}
                      validationMessage={i18n.t('common.fieldRequiredMessage')}
                      validationMessageMail={i18n.t(
                        'common.emailValidationMessage'
                      )}
                    />
                    <div className="amountCompanyPay">
                      Amount: $
                      {history?.location?.state?.amount
                        ? history?.location?.state?.amount / 100
                        : 0.0}
                    </div>
                  </div>
                );
              }
            });
          }}
        />
      </FormStyle.ButtonsWrapper>
      <Modal
        open={open}
        setOpen={setOpen}
        data={ModalListObject}
        onCloseModal={closeModal}
        withCloseIcon
        companyData
        alignItemsLeft
        width={720}
      />
    </Styled.Wrapper>
  );
};

export default Component;
